import { formatNumberPrecise } from '../../Utils';
import React from 'react';

// Round detail now comes from the parent (the round object already fetched by
// DailyHistoryViewer from /api/games/:game/history), so no Firestore read here.
const RoundDetails = ({ roundId, round }) => {
    if (!round) return null;
    const roundData = round;

    const bets = roundData.bets ? Object.entries(roundData.bets) : [];
    const wins = roundData.winnings ? Object.entries(roundData.winnings) : [];
    const winnerInfo = roundData.winnerInfo || {};
    const firstWinData = wins.length > 0 ? wins[0][1] : null;
    const showBalanceColumns = firstWinData && firstWinData.hasOwnProperty('balanceBeforeWin');

    const cellStyle = { padding: '8px 12px', fontSize: 13 };

    return (
        <div style={{ marginTop: 16, background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 12, padding: 16 }}>
            <h4 style={{ textAlign: 'center', fontWeight: 700, marginBottom: 14, color: '#f1f5f9' }}>Details for Round: {roundId}</h4>

            {/* Winner Info */}
            <div style={{ textAlign: 'center', marginBottom: 16, padding: '12px 20px', background: 'rgba(34,197,94,0.08)', border: '1px solid rgba(34,197,94,0.2)', borderRadius: 10 }}>
                <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: 13 }}>Winner: </span>
                <strong style={{ color: '#4ade80', fontSize: 16, marginLeft: 4 }}>
                    {winnerInfo.id ? winnerInfo.id.toUpperCase() : (winnerInfo.winnerSection || 'N/A')}
                </strong>
                <span style={{ color: 'rgba(255,255,255,0.6)', fontSize: 13, margin: '0 6px' }}>
                    {winnerInfo.payout
                        ? <> — Multiplier: <strong style={{ color: '#60a5fa' }}>{winnerInfo.payout}x</strong></>
                        : <> — <strong style={{ color: '#60a5fa' }}>{winnerInfo.winningHand || 'N/A'}</strong></>}
                </span>
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
                {/* Bets */}
                <div>
                    <h5 style={{ fontSize: 14, fontWeight: 700, color: '#60a5fa', marginBottom: 10 }}>All Bets ({bets.length})</h5>
                    {bets.length > 0 ? (
                        <div style={{ overflowX: 'auto', maxHeight: 300, overflowY: 'auto', borderRadius: 8, border: '1px solid rgba(255,255,255,0.08)' }}>
                            <table className="dark-table" style={{ margin: 0, border: 'none' }}>
                                <thead>
                                    <tr><th>User</th><th>Bets</th></tr>
                                </thead>
                                <tbody>
                                    {bets.map(([userId, betData]) => (
                                        <tr key={userId}>
                                            <td style={cellStyle}>
                                                <div style={{ fontWeight: 600 }}>{betData.username}</div>
                                                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>ID: {betData.customId || 'N/A'}</div>
                                            </td>
                                            <td style={cellStyle}>
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                                    {(betData.sectionBets
                                                        ? Object.entries(betData.sectionBets)
                                                        : Object.entries(betData).filter(([k]) => k !== 'username' && k !== 'customId')
                                                    ).map(([section, amount]) => (
                                                        <span key={section} className="badge badge-blue" style={{ fontSize: 11 }}>
                                                            {section}: {formatNumberPrecise(amount)}
                                                        </span>
                                                    ))}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : <p style={{ color: 'rgba(255,255,255,0.3)', textAlign: 'center', padding: '20px' }}>No bets were placed.</p>}
                </div>

                {/* Wins */}
                <div>
                    <h5 style={{ fontSize: 14, fontWeight: 700, color: '#4ade80', marginBottom: 10 }}>All Wins ({wins.length})</h5>
                    {wins.length > 0 ? (
                        <div style={{ overflowX: 'auto', maxHeight: 300, overflowY: 'auto', borderRadius: 8, border: '1px solid rgba(255,255,255,0.08)' }}>
                            <table className="dark-table" style={{ margin: 0, border: 'none' }}>
                                <thead>
                                    <tr>
                                        <th>User</th>
                                        {showBalanceColumns && <th style={{ textAlign: 'right' }}>Before</th>}
                                        <th style={{ textAlign: 'right' }}>Won</th>
                                        {showBalanceColumns && <th style={{ textAlign: 'right' }}>After</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {wins.map(([userId, winData]) => (
                                        <tr key={userId}>
                                            <td style={cellStyle}>
                                                <div style={{ fontWeight: 600 }}>{winData.username}</div>
                                                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)' }}>ID: {winData.customId || 'N/A'}</div>
                                            </td>
                                            {showBalanceColumns && <td style={{ ...cellStyle, textAlign: 'right', color: 'rgba(255,255,255,0.5)' }}>{formatNumberPrecise(winData.balanceBeforeWin)}</td>}
                                            <td style={{ ...cellStyle, textAlign: 'right', fontWeight: 700, color: '#4ade80' }}>+{formatNumberPrecise(winData.amountWon)}</td>
                                            {showBalanceColumns && <td style={{ ...cellStyle, textAlign: 'right', fontWeight: 600, color: '#f1f5f9' }}>{formatNumberPrecise(winData.balanceAfterWin)}</td>}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    ) : <p style={{ color: 'rgba(255,255,255,0.3)', textAlign: 'center', padding: '20px' }}>No winners this round.</p>}
                </div>
            </div>
        </div>
    );
};

export default RoundDetails;
